export const faqData = [
  {
    id: 1,
    question: '911黑料网是什么平台？',
    answer: '911黑料网是国内领先的娱乐爆料聚合平台，专注于收集、整理和发布娱乐圈最新独家黑料信息。我们汇聚全网吃瓜群众最关心的猛料内容，涵盖明星八卦、行业内幕、影视综艺幕后故事等，为读者提供第一手的热门爆料资讯。平台每日更新，确保你不错过任何重磅消息。',
  },
  {
    id: 2,
    question: '平台上的黑料信息来源可靠吗？',
    answer: '911黑料网所有爆料内容均经过多渠道交叉验证后再发布。我们拥有专业的爆料审核团队，对每一条投稿信息进行事实核查和来源追溯，确保内容真实可信。同时，平台标注了每条爆料的来源类型和可信度等级，方便读者自行判断。对于未经确认的传闻，我们会明确标注"待核实"标签。',
  },
  {
    id: 3,
    question: '如何第一时间获取最新爆料？',
    answer: '你可以通过以下方式获取最新资讯：收藏911黑料网首页并设为浏览器主页；关注我们的社交媒体账号获取推送提醒；使用浏览器的通知订阅功能接收实时更新；也可以将本站添加到手机桌面，像使用App一样随时浏览。我们每天早中晚三次固定更新，重大爆料即时推送。',
  },
  {
    id: 4,
    question: '可以向911黑料网匿名投稿吗？',
    answer: '完全可以。我们高度重视投稿人的隐私保护，支持完全匿名的投稿方式。你可以通过页面底部的投稿入口提交爆料内容，无需提供任何个人信息。所有投稿均经过加密传输，平台承诺不会追踪投稿人身份。如果你的爆料被采用并获得高热度，我们还提供丰厚的匿名奖励。',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '独家一手猛料',
    description: '专业采编团队深入一线，独家挖掘不为人知的劲爆内幕，全网首发率高达85%，领先同行至少12小时。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速更新响应',
    description: '7×24小时全天候监控全网动态，重大爆料事件发生后15分钟内完成核实与发布，让你永远快人一步。',
  },
  {
    id: 3,
    icon: 'ri-search-eye-line',
    title: '深度内幕挖掘',
    description: '不止于表面吃瓜，我们的资深编辑对每一条线索进行深度追踪，还原事件背后的完整真相链条。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '匿名安全守护',
    description: '投稿全程加密，采用多层匿名保护机制，从技术层面确保爆料人身份信息永不泄露，安全吃瓜无后顾之忧。',
  },
];

export const topicsData = [
  { id: 1, name: '顶流恋情', heat: '980万', tag: '爆', icon: 'ri-heart-pulse-line' },
  { id: 2, name: '综艺翻车', heat: '756万', tag: '热', icon: 'ri-tv-line' },
  { id: 3, name: '片酬曝光', heat: '632万', tag: '热', icon: 'ri-money-cny-circle-line' },
  { id: 4, name: '离婚实锤', heat: '588万', tag: '热', icon: 'ri-file-paper-2-line' },
  { id: 5, name: '选秀内定', heat: '521万', tag: '新', icon: 'ri-star-line' },
  { id: 6, name: '代言翻车', heat: '467万', tag: '新', icon: 'ri-alert-line' },
  { id: 7, name: '私生活起底', heat: '412万', tag: '新', icon: 'ri-user-search-line' },
  { id: 8, name: '影视合同纠纷', heat: '389万', tag: '', icon: 'ri-file-list-3-line' },
  { id: 9, name: '税务风波', heat: '355万', tag: '', icon: 'ri-bank-line' },
];

export const aboutData = {
  title: '关于我们',
  content:
    '911黑料网创立于2020年，是国内最具影响力的娱乐爆料聚合平台之一。我们致力于为全网吃瓜群众提供最新、最全、最有深度的娱乐黑料资讯。平台汇聚了超过500位资深爆料人和业内线人，日均更新独家内容超过200条，覆盖影视、音乐、综艺、体育、网红等全领域。三年来，911黑料网累计发布独家爆料超过15万条，其中被主流媒体跟进报道的比例高达62%，已成为行业内公认的"爆料风向标"。我们始终坚持"真实、快速、深度"的内容理念，为读者打造值得信赖的一站式吃瓜平台。',
  stats: [
    { value: '15万+', label: '独家爆料' },
    { value: '500+', label: '爆料线人' },
    { value: '3000万+', label: '月活用户' },
    { value: '62%', label: '媒体引用率' },
  ],
};

export const appData = {
  title: '移动端抢先体验',
  description:
    '将911黑料网添加到手机桌面，即可像使用原生App一样随时随地浏览最新爆料。支持iOS和Android系统，打开即用、无需下载、不占内存，推送提醒让你永远快人一步吃到第一口瓜。',
  features: ['一键添加到桌面', '实时推送提醒', '极速浏览体验', '离线缓存阅读'],
};

export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: '顶流男星深夜密会神秘女子，酒店同住实锤曝光',
    category: '恋情曝光',
    heat: '1023万',
    time: '2小时前',
    badge: '独家',
  },
  {
    id: 2,
    rank: 2,
    title: '某选秀节目导演组内部聊天记录流出，排名早已内定',
    category: '综艺黑幕',
    heat: '896万',
    time: '5小时前',
    badge: '实锤',
  },
  {
    id: 3,
    rank: 3,
    title: '知名导演被曝拖欠剧组工资，多名演员联合维权',
    category: '行业纠纷',
    heat: '754万',
    time: '8小时前',
    badge: '跟进',
  },
  {
    id: 4,
    rank: 4,
    title: '一线女星天价代言合同细节曝光，单年代言费破纪录',
    category: '商业内幕',
    heat: '689万',
    time: '12小时前',
    badge: '',
  },
  {
    id: 5,
    rank: 5,
    title: '当红小生涉嫌税务问题被约谈，工作室紧急发声明',
    category: '法制风波',
    heat: '601万',
    time: '1天前',
    badge: '热',
  },
];

export const contactData = {
  title: '爆料投稿',
  description:
    '你有猛料？欢迎匿名投稿！我们提供最安全的投稿通道，所有信息经过加密传输，绝不追踪投稿人身份。如果你的爆料信息被核实并发布，我们还将根据内容热度提供丰厚奖励。',
  email: 'tips@911heiliao.com',
  channels: [
    { name: '匿名投稿表单', icon: 'ri-mail-send-line', desc: '通过加密表单直接提交爆料内容' },
    { name: '加密邮箱投稿', icon: 'ri-mail-line', desc: '使用加密邮箱发送至投稿专用地址' },
    { name: '即时通讯投稿', icon: 'ri-message-2-line', desc: '通过加密即时通讯工具匿名联系' },
  ],
};

export const mediaData = [
  {
    id: 1,
    title: '独家直击：某顶流艺人片场与导演激烈争执全程',
    duration: '03:42',
    views: '289万',
    date: '2026-07-29',
    category: '独家直击',
  },
  {
    id: 2,
    title: '爆料人深度访谈：揭秘娱乐圈潜规则的冰山一角',
    duration: '12:18',
    views: '467万',
    date: '2026-07-28',
    category: '深度访谈',
  },
  {
    id: 3,
    title: '录音曝光：某经纪公司高层内部会议谈论艺人管控',
    duration: '05:30',
    views: '523万',
    date: '2026-07-27',
    category: '录音曝光',
  },
  {
    id: 4,
    title: '独家画面：某剧组庆功宴后多位艺人深夜密会现场',
    duration: '02:15',
    views: '891万',
    date: '2026-07-26',
    category: '独家画面',
  },
];

export const cardsData = [
  {
    id: 1,
    title: '重磅：某选秀节目导师私下收取选手好处费曝光',
    excerpt: '据知情人士透露，该导师通过中间人向多名选手索要数额不等的"指导费"，金额从数十万到上百万不等，目前已有至少5名选手站出来指证。',
    category: '选秀内幕',
    time: '3小时前',
    badge: '重磅',
    author: '深度调查组',
  },
  {
    id: 2,
    title: '某知名导演新片投资方撤资内幕：剧本争议引发连锁反应',
    excerpt: '该导演原定于下月开机的新片因剧本中涉及敏感题材，导致两大投资方先后撤资。据悉，剧本中涉嫌影射某真实事件，引发投资方担忧。',
    category: '影视内幕',
    time: '6小时前',
    badge: '独家',
    author: '影视线人',
  },
  {
    id: 3,
    title: '当红女星奢侈品代购账单流出，月均消费惊人',
    excerpt: '一份疑似某当红女星的海外代购账单在社交平台流传，账单显示其月均奢侈品消费超过200万元，其中某品牌包包单次购买多达15个。',
    category: '明星八卦',
    time: '9小时前',
    badge: '',
    author: '吃瓜编辑',
  },
  {
    id: 4,
    title: '经纪公司内部文件外泄：艺人违约金最高达5000万',
    excerpt: '一份据称来自某头部经纪公司的内部合同模板被曝光，其中违约金条款之苛刻令人咋舌，部分艺人即使解约也需支付高达5000万的违约金。',
    category: '行业揭秘',
    time: '12小时前',
    badge: '热',
    author: '合同解密组',
  },
  {
    id: 5,
    title: '某综艺节目录制现场意外：嘉宾被道具砸伤紧急送医',
    excerpt: '事故发生在该节目最新一期录制过程中，一座大型道具突然倒塌砸中一名飞行嘉宾。现场一度混乱，节目组随后紧急叫停录制并送伤者就医。',
    category: '综艺事故',
    time: '1天前',
    badge: '',
    author: '现场目击',
  },
  {
    id: 6,
    title: '知名音乐人新专辑涉嫌抄袭？多首曲目与海外作品高度雷同',
    excerpt: '有乐迷对比发现，该音乐人最新专辑中至少有3首歌曲与某海外独立音乐人的作品在旋律结构上高度相似，目前双方均未对此作出回应。',
    category: '音乐争议',
    time: '2天前',
    badge: '争议',
    author: '音乐线人',
  },
  {
    id: 7,
    title: '某影视公司CEO被曝挪用公司资金进行个人投资',
    excerpt: '内部财务审计报告显示，该CEO在未经董事会批准的情况下，先后多次将公司资金转入个人关联账户，累计金额超过3000万元。',
    category: '商业黑幕',
    time: '2天前',
    badge: '重磅',
    author: '财经调查',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '深度专题：2026上半年娱乐圈十大未解之谜全面复盘',
    excerpt: '从顶流恋情疑云到选秀节目黑幕，从明星税务风波到影视合同纠纷，我们梳理了今年上半年最受关注的十大娱乐圈悬案，逐一拆解背后的真相与隐情。',
    label: '半年盘点',
    tag: '专题',
  },
  {
    id: 2,
    title: '爆料档案：那些年被实锤后又反转的经典"打脸"事件',
    excerpt: '娱乐圈从来不缺反转。我们整理了近三年来最经典的爆料反转案例，从"铁证如山"到"完全诽谤"，看舆论如何在一夜之间天翻地覆。',
    label: '经典回顾',
    tag: '档案',
  },
  {
    id: 3,
    title: '行业深潜：娱乐圈"潜规则"产业链的完整运作模式揭秘',
    excerpt: '从选角、签约到宣发、分账，娱乐圈每个环节都有不为人知的灰色地带。本专题深度剖析这条完整产业链背后的利益输送与权力博弈。',
    label: '行业深潜',
    tag: '揭秘',
  },
  {
    id: 4,
    title: '吃瓜进阶：教你如何一眼识破娱乐圈假料与营销炒作',
    excerpt: '在信息爆炸的时代，真假爆料鱼龙混杂。我们的资深编辑总结了八大识破假料的实用技巧，帮助吃瓜群众修炼"火眼金睛"，不再被营销号牵着鼻子走。',
    label: '吃瓜指南',
    tag: '教程',
  },
];

export const updatesData = [
  {
    id: 1,
    time: '2026-07-30 14:32',
    title: '突发：某知名导演被多名女演员联合举报性骚扰，警方已介入调查',
    category: '突发事件',
  },
  {
    id: 2,
    time: '2026-07-30 11:15',
    title: '独家：某卫视跨年晚会艺人出场费内部报价表流出',
    category: '独家爆料',
  },
  {
    id: 3,
    time: '2026-07-30 09:48',
    title: '某当红男团成员被拍到与网红同游日本，粉丝后援会紧急辟谣',
    category: '恋情曝光',
  },
  {
    id: 4,
    time: '2026-07-29 22:10',
    title: '爆料人实锤：某选秀节目冠军选手学历造假，毕业院校根本不存在',
    category: '人设崩塌',
  },
  {
    id: 5,
    time: '2026-07-29 18:45',
    title: '某头部MCN机构被指压榨主播，分成比例不公平引发集体解约',
    category: '行业黑幕',
  },
  {
    id: 6,
    time: '2026-07-29 15:20',
    title: '独家：某国际奢侈品品牌中国区代言人即将换人，候选名单曝光',
    category: '商业动态',
  },
  {
    id: 7,
    time: '2026-07-29 10:05',
    title: '一线女演员被曝隐婚生子多年，经纪人回应称"纯属捏造"',
    category: '明星八卦',
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: '匿',
    name: '吃瓜一线群众',
    time: '2小时前',
    content: '看完这篇爆料真的震惊了，这个圈子也太乱了吧！感谢911黑料网的一手消息，比那些只会打马后炮的营销号强太多了。每天都在刷新我的三观，期待更多猛料！',
    likes: 2836,
    tag: '铁杆瓜友',
  },
  {
    id: 2,
    avatar: '爆',
    name: '资深爆料人老K',
    time: '5小时前',
    content: '作为在圈内混了十年的人，可以负责任地说这个平台80%的爆料都是真的。有些内容虽然看起来离谱，但现实比想象更魔幻。建议小编把那个导演的更多黑料也挖一挖，我们内部讨论很久了。',
    likes: 4521,
    tag: '圈内人士',
  },
  {
    id: 3,
    avatar: '瓜',
    name: '理性吃瓜小能手',
    time: '1天前',
    content: '关注911黑料网快两年了，从最初的半信半疑到现在的每日必看，这个平台的成长有目共睹。不过还是想提醒大家理性吃瓜，爆料归爆料，不要人身攻击艺人。另外希望平台继续保持真实客观，不要被资本裹挟。',
    likes: 1892,
    tag: '忠实读者',
  },
];

export const indexData = [
  {
    id: 1,
    title: '恋情曝光',
    count: 128,
    description: '明星地下恋情、秘密约会、隐婚隐离等恋爱相关爆料合集',
    icon: 'ri-heart-2-line',
  },
  {
    id: 2,
    title: '综艺黑幕',
    count: 96,
    description: '选秀内定、剧本作假、导师黑箱操作等综艺节目内幕整理',
    icon: 'ri-tv-2-line',
  },
  {
    id: 3,
    title: '行业揭秘',
    count: 215,
    description: '片酬体系、合同陷阱、经纪公司运作等娱乐圈行业规则深挖',
    icon: 'ri-building-line',
  },
  {
    id: 4,
    title: '人设崩塌',
    count: 87,
    description: '学历造假、慈善作假、伪善面具被撕等明星人设翻车全记录',
    icon: 'ri-ghost-line',
  },
  {
    id: 5,
    title: '商业黑幕',
    count: 143,
    description: '代言内幕、投资纠纷、税务问题等娱乐圈金钱相关的暗箱操作',
    icon: 'ri-money-cny-box-line',
  },
  {
    id: 6,
    title: '法律纠纷',
    count: 76,
    description: '合同诉讼、名誉维权、刑事案件等娱乐圈法律相关事件汇总',
    icon: 'ri-scales-line',
  },
  {
    id: 7,
    title: '独家专访',
    count: 54,
    description: '911黑料网独家采访爆料人、线人及业内知情人士的深度内容',
    icon: 'ri-mic-line',
  },
];

export const navLinks = [
  { label: '热议话题', href: '#topics' },
  { label: '热度榜单', href: '#ranking' },
  { label: '关于我们', href: '#about' },
  { label: '读者热评', href: '#comments' },
  { label: '专题索引', href: '#index' },
];

export const footerPartners = [
  '合作伙伴',
  '合作伙伴',
  '合作伙伴',
  '合作伙伴',
  '合作伙伴',
  '合作伙伴',
];